import { Table } from '@fareye/ui'
import React from 'react'
import { getTableColumns } from './Columns'
import { useTranslation } from '@fareye/common'
const COLUMNS = [
  {
    label: 'IMEI',
    key: 'imei'
  },
  {
    label: 'GSM PHONE NUMBER',
    key: 'gsmPhoneNumber'
  },
  {
    label: 'GSM PHONE NUMBER',
    key: 'phoneNumber'
  },
  {
    label: 'VEHICLE NO',
    key: 'vehicleNo'
  },
  {
    label: 'CREATED AT',
    key: 'createdAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'UPDATED AT',
    key: 'updatedAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Consigner ID',
    key: 'consignerId'
  },
  {
    label: 'Actions',
    key: 'action'
  }
]
export default function DeviceTable({
  deviceData: { data, meta, isLoading },
  setSelectedDevice,
  hideAction = false,
  setDevices,
  meta: metaInfo,
  setMeta
}: any) {
  const { t } = useTranslation()
  const selectedColumns = COLUMNS.filter(ele => {
    if (hideAction && (ele.key === 'action' || ele.key === 'gsmPhoneNumber')) {
      return false
    } else if (!hideAction && ele.key === 'phoneNumber') {
      return false
    }
    return true
  })
  return (
    <Table
      className="striped responsive"
      columns={getTableColumns(selectedColumns, {
        t,
        setSelectedDevice,
        hideAction,
        setDevices
      })}
      data={data}
      size="xs"
      sortable
      dataLoading={isLoading}
      totalElements={metaInfo.count}
      disablePageSizeChange
      defaultPageIndex={metaInfo.page - 1}
      defaultPageSizeOptions={[metaInfo.perPage]}
      onPageChange={(pageIndex: number) => {
        setMeta({ ...metaInfo, page: pageIndex + 1 })
      }}
    />
  )
}
